import { Pricing as App } from 'web-pages/v1/pages/pricing'

export function Pricing() {
  return <App />
}

export default Pricing
